import React from "react";
import s from "../ComparisonTable.module.scss";
import cn from "classnames";
import RichText from "../../Common/RichText";
import type { RichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";
import { isRichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";
import IconWithColor from "../../Common/IconWithColor";
import { useTranslation } from "next-i18next";

type RowColumnProps = {
  showStatus: boolean;
  status: "true" | "false" | "notApplicable";
  title: string;
  description?: RichTextContent;
  isHighlighted?: boolean;
  isBeforeHighlighted?: boolean;
  isAfterHighlighted?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const RowColumn: React.FC<RowColumnProps> = ({
  showStatus,
  status,
  title,
  description,
  isHighlighted,
  isBeforeHighlighted,
  isAfterHighlighted,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(s.cell, {
        [s.highlighted]: isHighlighted,
        [s.beforeHighlighted]: isBeforeHighlighted,
        [s.afterHighlighted]: isAfterHighlighted,
      })}
      role="cell"
      {...props}
    >
      {showStatus && (
        <div className={s.icon}>
          <IconWithColor
            icon={
              status === "notApplicable"
                ? "minus"
                : status === "true"
                ? "check"
                : "cancel"
            }
            width={18}
            height={18}
            alt={title || (status === "notApplicable" ? t("not-applicable") : status === "true" ? t("yes") : t("no"))}
            color={isHighlighted ? "white" : "black"}
          />
        </div>
      )}

      {title && <div className={s.title}>{title}</div>}
      {isRichTextContent(description) && description && (
        <RichText content={description} className={s.description} />
      )}
    </div>
  );
};

export default RowColumn;
